<template>
  <section class="solutions-section">
    <h2>Soluções de TI que impulsionam seu negócio</h2>
    <div class="solutions">
      <div class="solution-item">Consultoria em TI</div>
      <div class="solution-item">Desenvolvimento de Sistemas Personalizados</div>
      <div class="solution-item">Integração de Sistemas</div>
    </div>
  </section>
</template>

<script>
export default {
  name: "SolucoesComponent",
};
</script>

<style scoped>
.solutions-section {
  padding: 50px;
  background-color: #f5f5f5;
  text-align: center;
}
.solutions {
  display: flex;
  justify-content: space-around;
}
.solution-item {
  background-color: #fff;
  padding: 20px;
  width: 30%;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
}
</style>
